/* Product page gallery & interactions */
(function() {
  'use strict';

  // Gallery thumbnail switching
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const slides = document.querySelectorAll('.product-gallery__slide');
  let currentIndex = 0;

  function showSlide(index) {
    slides.forEach(s => s.classList.remove('product-gallery__slide--active'));
    thumbs.forEach(t => t.classList.remove('product-gallery__thumb--active'));
    if (slides[index]) slides[index].classList.add('product-gallery__slide--active');
    if (thumbs[index]) thumbs[index].classList.add('product-gallery__thumb--active');
    currentIndex = index;
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      showSlide(parseInt(thumb.dataset.index, 10));
    });
  });

  // Arrow navigation
  const prevBtn = document.querySelector('.product-gallery__arrow--prev');
  const nextBtn = document.querySelector('.product-gallery__arrow--next');
  if (prevBtn) prevBtn.addEventListener('click', () => {
    showSlide((currentIndex - 1 + slides.length) % slides.length);
  });
  if (nextBtn) nextBtn.addEventListener('click', () => {
    showSlide((currentIndex + 1) % slides.length);
  });

  // Quantity buttons
  const qtyInput = document.querySelector('.product-info__qty-input');
  document.querySelectorAll('.product-info__qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (btn.dataset.action === 'decrease') val = Math.max(1, val - 1);
      else val += 1;
      qtyInput.value = val;
    });
  });

  // Size pill selection (single-option products)
  const pills = document.querySelectorAll('.product-info__pill');
  const variantInput = document.querySelector('input[name="id"]');
  pills.forEach(pill => {
    pill.addEventListener('click', () => {
      const optionIndex = pill.dataset.optionIndex;
      document.querySelectorAll(`.product-info__pill[data-option-index="${optionIndex}"]`).forEach(p => p.classList.remove('product-info__pill--active'));
      pill.classList.add('product-info__pill--active');

      // Update variant ID for single-option products
      if (window.productVariants) {
        const selected = pill.dataset.value;
        const variant = window.productVariants.find(v => v.option1 === selected);
        if (variant && variantInput) {
          variantInput.value = variant.id;
          // Update price in add-to-cart button
          const addBtn = document.querySelector('.product-info__add-btn');
          if (addBtn && variant.available) {
            addBtn.innerHTML = 'ADD TO CART &bull; ' + variant.price_formatted;
            addBtn.disabled = false;
          } else if (addBtn) {
            addBtn.innerHTML = 'SOLD OUT';
            addBtn.disabled = true;
          }
        }
      }
    });
  });
})();
